import * as React from 'react';
import { Palette } from '../../lib/constants.js';
import { createIcon } from '../IconFactory/index.js';

const CheckCircle = createIcon('CheckCircle')(({ fillColor = Palette.NeutralGrey3, ...others }) => (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", fill: fillColor, ...others },
    React.createElement("path", { d: "M8 14A6 6 0 108 2a6 6 0 000 12zm0 2A8 8 0 118 0a8 8 0 010 16zm2.707-10.78a.754.754 0 011.066 0 .775.775 0 010 1.097l-4.486 4.462a.754.754 0 01-1.066 0L4.227 8.796a.775.775 0 010-1.096.754.754 0 011.066 0l1.46 1.453 3.954-3.932z" }))));

export { CheckCircle };
//# sourceMappingURL=index.js.map
